import type { ReactNode } from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { getInitials } from "../../functions/udfHelper";
import shiPallete from "../../theme/shiPalette";

type LifecycleManagementAccountExecutiveFieldProps = {
  accountExecutive?: string | null;
  avatar?: ReactNode;
};

export function LifecycleManagementAccountExecutiveField({
  accountExecutive,
  avatar,
}: Readonly<LifecycleManagementAccountExecutiveFieldProps>) {
  if (!accountExecutive) {
    return <Typography variant="body2">--</Typography>;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1,
        width: "100%",
        height: "100%",
      }}
    >
      {avatar ?? (
        <Avatar
          sx={{
            width: 28,
            height: 28,
            fontSize: 12,
            flexShrink: 0,
            bgcolor: shiPallete.secondary.light,
            color: shiPallete.text.primary,
            justifyContent: "center",
          }}
        >
          {getInitials(accountExecutive)}
        </Avatar>
      )}
      <Typography variant="body2" noWrap sx={{ textTransform: "capitalize" }}>
        {accountExecutive}
      </Typography>
    </Box>
  );
}
